var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { SuggestionField } from './SuggestionField';
import { TextEditor } from '@periscopes/general/editor';
import { useSuggestionEditor } from '@hooks';
import React, { useCallback, useRef, useState } from 'react';
export const SuggestTextCellEditor = (_a) => {
    var { autodocType, getPopupContainer, isReadOnly, onSave, sonarObjectId, value } = _a, rest = __rest(_a, ["autodocType", "getPopupContainer", "isReadOnly", "onSave", "sonarObjectId", "value"]);
    const editorRef = useRef(null);
    const [hasContent, setHasContent] = useState(false);
    const suggestion = useSuggestionEditor({
        autodocType,
        isReadOnly,
        richText: true,
        sonarObjectId,
        value
    });
    const onEdit = useCallback(() => {
        var _a;
        suggestion.accept();
        (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.edit();
    }, [suggestion]);
    const onAccept = useCallback(() => {
        var _a;
        suggestion.accept();
        (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.save();
    }, [suggestion]);
    const onFocus = useCallback(() => {
        suggestion.accept();
    }, [suggestion]);
    const onBlur = useCallback(() => {
        const userInput = !suggestion.value && hasContent;
        if (!(suggestion.value && suggestion.accepted) && !userInput) {
            suggestion.reset();
        }
    }, [hasContent, suggestion]);
    const handleContentCheck = useCallback((hasEditorContent) => {
        setHasContent(hasEditorContent);
    }, []);
    return (React.createElement(SuggestionField, { autodocType: autodocType, isReadOnly: isReadOnly, isSpreadsheet: true, onAccept: onAccept, onBlur: onBlur, onEdit: onEdit, suggestion: suggestion },
        React.createElement(TextEditor, Object.assign({}, rest, { canBeEmpty: true, content: suggestion.editorValue, contentCheck: handleContentCheck, getPopupContainer: getPopupContainer, isReadOnly: isReadOnly, isSpreadsheet: true, onBlur: onBlur, onFocus: onFocus, onSave: onSave, ref: editorRef }))));
};
